export const SUBCONTRACTOR_SIGNUP_PATH = '/subcontractor/company/signup';

// RoutesNames matches routes from ComplianceMenuService
export enum RouteNames {
    PERSONAL_DETAILS = 'my-personal-details',
    BUSINESS_DETAILS = 'my-business-details',
    LEGAL_DOCUMENTS = 'my-legal-documents',
    BANK_ACCOUNT = 'my-payments',
    UMBRELLA_FREELANCER_REQUEST = 'my-freelancer-request',
    PAYMENTS_LINK = 'payments-link',
}
